import { FieldViewport } from '../../models/index.js';
import { usePlayEditor, usePlayTheme } from '../../providers/index.js';
import { getFieldRotation } from '../../utils/index.js';

interface Props {
    backgroundImage?: string;
    fieldViewport: FieldViewport;
    centeredOn: Point;
    size: number;
    rotation: number;
}

const FieldLogo: FC<Props> = ({ backgroundImage, fieldViewport, centeredOn, size, rotation, ...props }) => {
    const { Watermark } = usePlayEditor();
    const { getFieldStyle } = usePlayTheme();
    const { fieldLogoOpacity } = getFieldStyle();

    const finalRotation = getFieldRotation(fieldViewport, rotation);
    const totalProps = {
        ...props,
        className: 'field-team-logo',
        opacity: fieldLogoOpacity,
        width: fieldViewport.getPixelLength(size),
        height: fieldViewport.getPixelLength(size),
        x: fieldViewport.flippedX
            ? fieldViewport.getPixelX(centeredOn.x + size / 2)
            : fieldViewport.getPixelX(centeredOn.x - size / 2),
        y: fieldViewport.flipped
            ? fieldViewport.getPixelY(centeredOn.y + size / 2)
            : fieldViewport.getPixelY(centeredOn.y - size / 2),
        transform: `rotate(${finalRotation}, ${fieldViewport.getPixelX(centeredOn.x)} ${fieldViewport.getPixelY(
            centeredOn.y
        )})`,
    };

    return backgroundImage ? <image xlinkHref={backgroundImage} {...totalProps} /> : <Watermark {...totalProps} />;
};

export default FieldLogo;
